import styled from "styled-components";

export const Wrapper = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "flex-start",
  gap: 6,
  padding: "8px 12px",
  backgroundColor: "#f0f7ff",
  border: "1px solid #d1e7ff",
  borderRadius: 6,
  marginTop: 8,
  fontSize: 12,
  lineHeight: 1.5,

  [theme.down("sm")]: {
    fontSize: 11,
    padding: "6px 10px",
  },
}));

export const HintIcon = styled("span")(({ theme }) => ({
  flexShrink: 0,
  fontSize: 14,
  marginTop: 1,
}));

export const HintText = styled("span")(({ theme }) => ({
  color: "#0066cc",
  flex: 1,
}));

